<div class="text-center">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="menu-button"
              data-testid="transaction-options-menu"
              matTooltipPosition="right"
              matTooltip="open options menu">
      more_horiz
    </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <div class="text-center" *hasPermission="permissionTypes.DownloadPlayerReceipts">
    <button mat-menu-item
            data-testid="download-receipt-button"
            (click)="downloadReceipt()"
            [disabled]="isDownloadingReceipt">
      <mat-icon class="dark-grey menu-icon">
        receipt
      </mat-icon>
      <span class="dark-grey menu-text">
        Download Receipt
      </span>
    </button>
  </div>
  <div class="text-center" *hasPermission="permissionTypes.IssueRefund">
    <button mat-menu-item
            data-testid="issue-refund-button"
            (click)="onIssueRefund(rowData.StripeChargeId)">
      <mat-icon class="dark-grey menu-icon">
        currency_exchange
      </mat-icon>
      <span class="dark-grey menu-text">
        Issue Refund
      </span>
    </button>
  </div>
</mat-menu>
